import { render, staticRenderFns } from "./ContestEditComponent.vue?vue&type=template&id=0ba1e078"
import script from "./ContestEditComponent.vue?vue&type=script&lang=js"
export * from "./ContestEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports